module.exports = __webpack_public_path__ + "img/icon_instagram_inverse_y.ee0dcb93.svg";